<template>
  <footer class="app-footer">
    <div class="page-container app-footer__inner">
      <div class="app-footer__links">
        <router-link to="/terms">用户服务协议</router-link>
        <span class="app-footer__sep">·</span>
        <router-link to="/updates">版本更新日志</router-link>
        <span class="app-footer__sep">·</span>
        <router-link to="/qrcode">关注公众号</router-link>
      </div>

      <p class="app-footer__copy">
        © 2026 上海艾莉亚网络科技有限公司 版权所有
        <span class="app-footer__bar">|</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">沪ICP备2021028632号-2</a>
        <span class="app-footer__bar">|</span>
        增值电信业务许可证：<a href="https://dxzhgl.miit.gov.cn" target="_blank" rel="noopener">沪B2-20250747</a>
      </p>
    </div>
  </footer>
</template>

<script setup>
// 底栏：品牌 + 法律链接 + 备案信息（干净简洁，配色融入页面暖色背景）
</script>

<style scoped>
.app-footer {
  margin-top: 48px;
  padding: 36px 0 32px;
  border-top: 1px solid var(--color-border);
  background: transparent;
}

.app-footer__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.app-footer__links {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--color-text-3);
}

.app-footer__links a:hover {
  color: var(--color-primary);
}

.app-footer__sep {
  color: var(--color-text-4);
}

.app-footer__copy {
  margin: 0;
  font-size: 12px;
  line-height: 1.8;
  color: var(--color-text-4);
}

.app-footer__copy a {
  color: var(--color-text-4);
}

.app-footer__copy a:hover {
  color: var(--color-primary);
}

.app-footer__bar {
  margin: 0 6px;
}
</style>
